import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

import api from "api"

import Hello from '@/components/Hello'
import CsvAnalyzer from '@/components/CsvAnalyzer'
import AccountSettings from '@/components/AccountSettings'

import LoginForm from '@/components/emailPassword/LoginForm'
import Logout from '@/components/user/Logout'
import ResetPassword from '@/components/emailPassword/ResetPassword'
import ConfirmEmail from '@/components/emailPassword/ConfirmEmail'
import RegisterForm from '@/components/emailPassword/RegisterForm'
import ConfirmRegister from '@/components/emailPassword/ConfirmRegister'

import Order from '@/components/Order'

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      redirect: { name: 'csv-words' }
    },
    {
      path: '/login/:redirect',
      name: 'login',
      component: LoginForm,
      meta: { requiresLogout: true }
    },
    {
      path: '/sign-up',
      name: 'register',
      component: RegisterForm,
      meta: { requiresLogout: true }
    },
    {
      path: '/sign-out',
      name: 'logout',
      component: Logout
    },
    {
      path: '/confirm-sign-up/:key',
      name: 'confirm-register',
      component: ConfirmRegister
    },
    {
      path: '/home',
      name: 'Hello',
      component: Hello
    },
    {
      path: '/csv/words',
      name: 'csv-words',
      component: CsvAnalyzer,
      props: {
        analyzer: {
          type: 'words'
        }
      },
      meta: { requiresLogin: true}
    },
    {
      path: '/csv/ads',
      name: 'csv-ads',
      component: CsvAnalyzer,
      props: {
        analyzer: {
          type: 'ads'
        }
      },
      meta: { requiresLogin: true }
    },
    {
      path: '/user',
      name: 'account-settings',
      component: AccountSettings,
      meta: { requiresLogin: true }
    },
    {
      path: '/reset-password/:key',
      name: 'reset-password',
      component: ResetPassword,
      meta: { requiresLogout: true }
    },
    {
      path: '/change-email/:key',
      name: 'change-email',
      component: ConfirmEmail
    },
    {
      path: '/order',
      name: 'order',
      component: Order,
      meta: { requiresLogin: true }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if(to.matched && to.matched[0] && to.matched[0].meta) {
    if (to.matched[0].meta.requiresLogin) {
      if (!api.session.loggedIn) {
        console.log("REDIRECT TO LOGIN!")
        next({
          name: 'login',
          params: {redirect: to.fullPath}
        })
        return
      }
    }
  }

  next();
})

let routerReactions = new Vue({
  data() { return {} },
  computed: {
    loggedIn() { return api.session.loggedIn }
  },
  watch: {
    loggedIn(v) {
      if(v) {
        console.log("LOGGED IN!")
        if(router.currentRoute.meta.requiresLogout) {
          if(router.currentRoute.params.redirect) {
            router.replace(router.currentRoute.params.redirect)
          } else {
            router.replace({ name: 'index' })
          }
        }
      } else {
        console.log("LOGGED OUT!")
        if(router.currentRoute.meta.requiresLogin) {
          router.replace({
            name: 'login',
            params: { redirect: router.currentRoute.fullPath }
          })
        }
      }
    }
  }
})

window.rtr = router

export default router



// WEBPACK FOOTER //
// ./src/router/index.js